import { render, staticRenderFns } from "./sip-page-intro.vue?vue&type=template&id=789e01e8"
import script from "./sip-page-intro.vue?vue&type=script&lang=js"
export * from "./sip-page-intro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('789e01e8')) {
      api.createRecord('789e01e8', component.options)
    } else {
      api.reload('789e01e8', component.options)
    }
    module.hot.accept("./sip-page-intro.vue?vue&type=template&id=789e01e8", function () {
      api.rerender('789e01e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/sip-page-intro.vue"
export default component.exports